import React from "react";

export function BriefcaseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <path
        fill="#16161D"
        fillRule="evenodd"
        d="M6.5 1.75C6.5.784 7.284 0 8.25 0h5.5c.966 0 1.75.784 1.75 1.75V4h4.75c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0120.25 22H1.75A1.75 1.75 0 010 20.25V5.75C0 4.784.784 4 1.75 4H6.5V1.75zm-5 10.24v8.26c0 .138.112.25.25.25h18.5a.25.25 0 00.25-.25v-8.26A4.233 4.233 0 0117.75 13H4.25a4.233 4.233 0 01-2.75-1.01zm19-3.24a2.75 2.75 0 01-2.75 2.75H4.25A2.75 2.75 0 011.5 8.75v-3a.25.25 0 01.25-.25h18.5a.25.25 0 01.25.25v3zm-6.5-7V4H8V1.75a.25.25 0 01.25-.25h5.5a.25.25 0 01.25.25z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}